import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const configTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e1f5e1',
      100: '#b3e6b3',
      200: '#80d980',
      300: '#4dc74d',
      400: '#26b826',
      500: '#00923f',
      600: '#007b2e',
      700: '#006622',
      800: '#004d1a',
      900: '#003612',
      950: '#002209'
    }
  },
  components: {
    menu: {
      root: {
        borderColor: 'transparent',
      },
    },
    drawer: {
      root: {
        borderColor: 'transparent',
      }
    }
  }
});

export default configTheme;